import KanbanPage from "../../../../components/kanban";
import MaintenanceTracking from "../../../../components/maintenanceTracking";
import { NewUiGate } from "../../../../features/newUi";

const MaintenanceMonitoring = (props: any) => {
    return (
        <NewUiGate
            legacy={<KanbanPage persona="CONSULTANT" {...props} />}
            next={<MaintenanceTracking persona="CONSULTANT" {...props} />}
        />
    );
};

export default MaintenanceMonitoring;
